module.exports = __webpack_public_path__ + "img/color-companion-2_en.6a31d93.jpg";